import React from "react";
import { PulsePageControlContentProps } from "@features/pulse/utils/types";
import PulseDesktopCarousel from "@features/pulse/variant/control/components/PulseDesktopCarousel/PulseDesktopCarousel";

export type PulseDesktopPageProps = Omit<
  PulsePageControlContentProps,
  "handleSetActiveArticle" | "offset"
>;

/**
 * PulseDesktopPage is a React component that renders the desktop version of the Pulse variant control.
 * It displays a carousel of articles and handles navigation between them.
 */
export default function PulseDesktopPage({
  sortedPulseArticles,
  activeArticle,
  handleNavigateLeftCard,
  handleNavigateRightCard,
  backToBt = "/",
}: PulseDesktopPageProps): React.ReactElement {
  if (sortedPulseArticles.length === 0) return <></>;

  return (
    <div
      data-testid="pulse-desktop-page"
      className="w-svh hidden h-[calc(100svh_-_60px)] items-center justify-center overflow-x-hidden lg:flex"
    >
      <PulseDesktopCarousel
        sortedPulseArticles={sortedPulseArticles}
        activeArticle={activeArticle}
        handleNavigateLeftCard={handleNavigateLeftCard}
        handleNavigateRightCard={handleNavigateRightCard}
        backToBt={backToBt}
      />
    </div>
  );
}
